import styled from "styled-components"

export default function PrivacyConsent() {
  return (
    <PrivacyConsentBlock>
      <Paragraph>(필수) 개인정보 제3자 제공동의</Paragraph>
      <Paragraph>
        모티너스 회원 계정으로 신한 챌린지를 참여하는 경우,
      </Paragraph>
      <Paragraph>
        챌린지 리워드(상금) 제공을 위해 아래와 같이 제휴사에
      </Paragraph>
      <Paragraph>
        개인(신용)정보를 제공합니다.
      </Paragraph>
      <br />
      <Paragraph>
        1. 개인정보를 제공받는 자
      </Paragraph>
      <Paragraph>
        제휴사 : 신한은행
      </Paragraph>
      <br />
      <Paragraph>
        2. 제공하는 개인정보 항목
      </Paragraph>
      <Paragraph>
        계좌번호, 이름, 휴대폰번호
      </Paragraph>
      <br />
      <Paragraph>
        3. 개인정보를 제공받는 자의 개인정보 이용목적
      </Paragraph>
      <Paragraph>
        챌린지 리워드(상금) 지급을 위한 자격 확인, 본인 명의 계좌번호 인증, 상금 지급을 위한 자격확인
      </Paragraph>
      <br />
      <Paragraph>
        4. 개인정보를 제공받는 자의 개인정보 보유 및 이용기간
      </Paragraph>
      <Paragraph>
      신한 챌린지 종료 후 상금 지급 기한 완료 후 3개월까지 회원 가입 기간 동안 정보를 저장합니다. 단, 관계 법령 의 규정에 의하여 일정 기간 보존이 필요한 경우에는 해당 기간만큼 보관 후 삭제합니다. 이력 확인 및 분쟁조 정(타인에 의한 정보 변경등)을 위해 변경 전 본인확인 정보는 1년간 보관 후 파기합니다.
      </Paragraph>
      <br />
      <Paragraph>
      모티너스 회원은 위 개인정보 제공 동의를 거부할 권리가 있으나, 위 개인정보 제공 동의 거부 시 신한은행 챌린지의 리워드(상금) 지급이 불가능합니다. 그 밖의 내용은 모티너스 개인정보 처리방침을 따릅니다.
      </Paragraph>
    </PrivacyConsentBlock>
  )
}

const PrivacyConsentBlock = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  padding-top: calc(100vw * (16 / 375));
  padding-right: calc(100vw * (17 / 375));
  padding-left: calc(100vw * (17 / 375));
`

const Paragraph = styled.p`
  white-space: pre-wrap;
  font-size: calc(100vw * (14 / 375));
  font-weight: 400;
  line-height: calc(100vw * (16.8 / 375));
  color: #121212;
`;